export const LIST_REGISTERS_GLOBAL = 'REGISTER/LIST_REGISTERS_GLOBAL'
export const LIST_REGISTERS_GLOBAL_SUCCESS = 'REGISTER/LIST_REGISTERS_GLOBAL_SUCCESS'
export const LIST_REGISTERS_GLOBAL_FAILED = 'REGISTER/LIST_REGISTERS_GLOBAL_FAILED'

export const UPDATE_OFFLINE_ACTION = 'REGISTER/UPDATE_OFFLINE_ACTION'

export const CLEAR_OFFLINE_ACTIONS = 'REGISTER/CLEAR_OFFLINE_ACTIONS'
